module.exports = __webpack_public_path__ + "img/sveabusiness.72a0509.png";